/*
 * @Description:
 * @Author: Teemo D
 * @Date: 2021-03-22 16:11:05
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-08 13:47:58
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorProfilePage/TopConfigs/BackgroundStyle/index.tsx
 */
import React, { Fragment } from 'react';

import { useDispatch } from 'react-redux';

import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import _ColorPickerWidthTitle from 'src/pages/SalesChannelContentEditor/Components/ColorPickerWidthTitle';
import _ImageWidthTitle from 'src/pages/SalesChannelContentEditor/Components/ImageWidthTitle';
import { validateImageStateSetting } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorProfilePage/tools';

import { EnumCollapseId } from '../../common';
import css from './css.less';

import { ItemWrapper } from '@/src/components';
import ColorPicker from '@/src/components/ColorPicker/ColorPicker';
import { getI18nFromGeneral } from '@/src/tools/tools';
import { EPreviewSize, WebSiteSubType } from '@/src/types/common/SalesChannel';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import {
  getBackgroundStyle,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getSubmitStamp,
  onBackgroundStyleChange,
  onCollapseOpen,
  onErrorChange,
} from '../../slice';
const BackgroundStyle = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data, isPrimary, currentStyle, currentSize, disabled } = props;
  const _d = useDispatch();
  const { image, backgroundColor, primaryColor, tabColor, textColor } = data;
  const handleOnColorChange = (prop, color) => {
    _d(onBackgroundStyleChange({ [prop]: color }));
  };

  const handleImageChange = (img) => {
    _d(onBackgroundStyleChange({ image: img }));
  };

  switch (currentStyle) {
    case WebSiteSubType.NativeMobile: {
      return (
        <Fragment>
          <Section className={css.section}>
            <_ImageWidthTitle
              title={getI18n('general.tools_helper.image')}
              image={image}
              subtitle={getI18n('general.checkImgDraggableDisplay.subtitle')}
              onImageChange={handleImageChange}
              disabled={disabled}
              hideEdit={false}
            />
            {isPrimary && (
              <React.Fragment>
                <_ColorPickerWidthTitle
                  multi
                  onChange={handleOnColorChange.bind(null, 'backgroundColor')}
                  color={backgroundColor}
                  title={getI18n('general.backgroundColour')}
                  subtitle={getI18n(
                    'salesChannelContent.index.searchiconmultilanguagesicon',
                  )}
                />
              </React.Fragment>
            )}
          </Section>
        </Fragment>
      );
    }
    case WebSiteSubType.ResponsivePage: {
      switch (currentSize) {
        case EPreviewSize.WIDE: {
          return (
            <React.Fragment>
              <Section className={css.section}>
                <_ImageWidthTitle
                  title={getI18n('general.tools_helper.image')}
                  image={image}
                  subtitle={getI18n(
                    'general.checkImgDraggableDisplay.subtitle',
                  )}
                  onImageChange={handleImageChange}
                />
                {isPrimary && (
                  <React.Fragment>
                    <ItemWrapper
                      title={getI18n(
                        'salesChannelContent.index.primaryColour',
                      )}>
                      <ColorPicker
                        multi
                        onChange={handleOnColorChange.bind(
                          null,
                          'primaryColor',
                        )}
                        color={primaryColor}
                      />
                    </ItemWrapper>
                    <ItemWrapper title={getI18n('general.textColour')}>
                      <ColorPicker
                        multi
                        onChange={handleOnColorChange.bind(null, 'textColor')}
                        color={textColor}
                      />
                    </ItemWrapper>
                    <ItemWrapper
                      title={getI18n('salesChannelContent.index.tabColour')}>
                      <ColorPicker
                        multi
                        onChange={handleOnColorChange.bind(null, 'tabColor')}
                        color={tabColor}
                      />
                    </ItemWrapper>
                  </React.Fragment>
                )}
              </Section>
            </React.Fragment>
          );
        }
        case EPreviewSize.TABLET: {
          return (
            <React.Fragment>
              <Section className={css.section}>
                <_ImageWidthTitle
                  title={getI18n('general.tools_helper.image')}
                  image={image}
                  subtitle={getI18n(
                    'general.checkImgDraggableDisplay.subtitle',
                  )}
                  onImageChange={handleImageChange}
                  showDisplaySetting
                />
              </Section>
            </React.Fragment>
          );
        }
        case EPreviewSize.MOBILE: {
          return (
            <React.Fragment>
              <Section className={css.section}>
                <_ImageWidthTitle
                  title={getI18n('general.tools_helper.image')}
                  image={image}
                  subtitle={getI18n(
                    'general.checkImgDraggableDisplay.subtitle',
                  )}
                  onImageChange={handleImageChange}
                  showDisplaySetting
                />
              </Section>
            </React.Fragment>
          );
        }
      }
    }
  }
};
// export default BackgroundStyle;
export default ErrorProcessingHOC(BackgroundStyle, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.backgroundStyle,
  getContent: getBackgroundStyle,
  title: getI18nFromGeneral('general.hOCTitle.backgroundStyle'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  validation: validateImageStateSetting,
  getSubmitStamp: getSubmitStamp,
});
